import { IVehicleBase, IDriverBase, IPerson, IAddress, IListOption, IAdditionalDriver, IContactInfo } from "./Domain";

export interface ILienholder {
    name: string,
    address: IAddress | null;
}

export interface ICoverage {
    name: string,
    limit: string,
    premiumAmt: string;
}

export interface IVehicle extends IVehicleBase {
    isLeased: boolean,
    changed: boolean,
    wasSalvaged: boolean | null,
    hasLienholder: boolean,
    coverages: Array<ICoverage>,
    lienholder : ILienholder | null;
}

export interface IAgreement {
    agreeDrivers: boolean,
    agreeVehicles: boolean,
    agreeOtherDrivers: boolean,
    agreeSalvage: boolean,
    agreeEmailCorrect: boolean,
    agreePolicyEffDate: boolean
}

export interface IMvrResult {
    success: boolean,
    hasViolationData: boolean,
    mvrDriversResults: Array<IMvrDriverResult>,
    additionalDrivers: Array<IAdditionalDriver>
}

export interface IMvrDriverResult {
    driverId: number,
    status: string,
    violations: Array<IViolation>,
    needShow: boolean
}

export interface IViolation {
    id: number,
    driverId: number,
    incidentDescription : string,
    date: string,
    isAccident : boolean,
    allowedDispute: boolean,
    accDisSet: string | null,
    disputeOptions: Array<IListOption> | null
}

export interface IPolicyDocument {
    name: string,
    downloadUrl: string;
}

export interface IBindResult {
    isSuccess : boolean,
    policyNumber  : string,
    errors : Array<string>,
    documents: Array<IPolicyDocument>;
}

export interface IUpdateVehicleResult {
    isSuccess: boolean,
    errors: Array<string>,
    vehicleChanged: boolean,
    wasSalvaged: boolean,
    isRerated: boolean;
}

export interface IUpdateDriverResult {
    isSuccess: boolean,
    errors: Array<string>,
    birthDtChanged: boolean,
    licenseStateChanged: boolean,
    isRerated: boolean;
}

export interface IUpdateAdditionalDriverResult {
    errors: Array<string>,
    hasErrors: boolean,
    drivers: Array<IDriverBase>,
    driversWasChanged: boolean
}

export interface IUpdateCreditCardResult {
    errors: Array<string>,
    paymentPlanCode: number;
}

export interface IBindQuoteResult {
    isSuccess: boolean,
    errors: Array<string>;
}

export interface IExternalQuote {
    rtrQuoteId: number, // pc submission_id
    id: number, // lob submission id
    //number: number,
    paymentPlanCode: number,
    effectiveDate: string,
    effectiveDatetimeStamp: string,
    installmentDueDate: string,
    insured: IPerson,
    agreement: IAgreement | null,
    vehicles: Array<IVehicle>,
    drivers: Array<IDriverBase>,
    mvrResult: IMvrResult,
    reRated: boolean,
    hasMvrViolations: boolean,
    esignatureForms: Array<IESignatureForm>,
    bindResult: IBindResult | null,
    hasAdditionalDrivers: boolean,
    contactInfo: IContactInfo | null;
}

export interface IESignatureForm {
    code: string,
    name: string,
    displayOrder: number,
    module: IEsignatureModule,
    processed: boolean
}

export interface IEsignatureModule {
    needToSign: boolean,
    applicantSignature: string,
    wording: string,
    esigStart: string,
    esigEnd: string,
    moduleOptions: Array<IEsignatureModuleOption>
}

export const ESIG_MODULE_OPTION_TYPES = {
    YES_NO: 1,
    PHONE_NUMBER: 2,
    YES_NO_SELECTED: 3
}

export interface IEsignatureModuleOption {
    label: string,
    value: string,
    type: number,
    isValid: boolean | null
}
